import { Injectable } from "@angular/core";
import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { configurationSubject } from 'src/app/environment-resolver';

@Injectable({
  providedIn: 'root'
})
export class LaunchDarklyService {
    private readonly client!: LaunchDarkly.LDClient;
    private readonly context!: LaunchDarkly.LDContext;

    constructor() {
        this.context = {
            kind: 'user',
            anonymous: true
        };

        const ldKey = configurationSubject.getValue().launchDarklyKey;
        this.client = LaunchDarkly.initialize(ldKey, this.context);
    }

    // Return flag value as observable
    getFlag(flagKey: string, defaultFlag: LDFlagValue = false): Observable<LDFlagValue> {
        return from(this.client.waitUntilReady()).pipe(
            map(() => {
                return this.client.variation(flagKey, defaultFlag);
            })
        );
    }

    getStaticFlag(flagKey: string, defaultFlag: LDFlagValue = false): LDFlagValue {
        return this.client.variation(flagKey, defaultFlag);
    }
}


